import { Type } from '@sinclair/typebox';
import { getChannel } from '@ayocore/platform/messaging/client';
import {
  ActivityChannelMessageSchema,
  type ActivityChannelMessage,
} from '../common/types/activity-message';

export const crmActivityChannel = getChannel<unknown, ActivityChannelMessage>(
  'crm-activity'
).withSchema(Type.Unknown(), ActivityChannelMessageSchema);
